import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import PropTypes from 'prop-types';
import Moment from 'react-moment';
import './TenderWonNotification.css';

class TenderWonNotification extends Component {
    static propTypes = {
        data: PropTypes.object.isRequired
    };
    static defaultProps = {};
    state = {};

    constructor(props) {
        super(props);

        this.state.data = props.data;
    }

    render() {
        const {data, ...state} = this.state;
        return (
            <div className="widget-notifications-item">
                <div className="widget-notifications-title text-success">Вы выиграли</div>
                <div className="widget-notifications-description">
                    Вы выиграли <Link to={`/tenderRequests/underway/details/${data.tenderId}`}>тендер № <strong>{data.tenderNumber}</strong></Link> на сумму {data.tenderSum} тыс. руб. с доставкой <strong><Moment format="DD MMMM YYYY" locale="ru">{data.deliveryDate}</Moment></strong>
                </div>
                <div className="widget-notifications-date">
                    <Moment fromNow locale="ru">{data.timestamp}</Moment>
                </div>
                <div className="widget-notifications-icon fa fa-thumbs-up bg-success"/>
            </div>
        );
    }
}

export default TenderWonNotification;


// WEBPACK FOOTER //
// ./src/components/Notifications/TenderWonNotification.js